import { Box, Button, Container, Stack, Typography } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { APP_NAME } from '../../Shared/branding';
import Logo from '../../Components/Logo';
import { ON_DARK } from './constants';

const footerLinkSx = {
	color: ON_DARK.text,
	'&:hover': { color: 'warning.main' },
};

const Footer = () => {
	const navigate = useNavigate();

	return (
		<>
			<Box
				id="get-started"
				component="section"
				sx={{ py: { xs: 7, md: 9 }, scrollMarginTop: { xs: 72, md: 80 } }}
			>
				<Container maxWidth="sm" sx={{ textAlign: 'center' }}>
					<Typography variant="h5" sx={{ fontWeight: 700, mb: 1.5 }}>
						Ready to get started?
					</Typography>
					<Typography
						variant="body1"
						color="text.secondary"
						sx={{ mb: 3, lineHeight: 1.75 }}
					>
						Start your 30-day free trial. Send a proposal today — Bidzbase
						follows up if they don&apos;t answer. No credit card.
					</Typography>
					<Button
						variant="contained"
						color="warning"
						size="large"
						onClick={() => navigate('/signup')}
						sx={{ px: 4 }}
					>
						Start free trial
					</Button>
				</Container>
			</Box>

			<Box
				component="footer"
				sx={{
					py: 4,
					backgroundColor: (theme) =>
						theme.palette.mode === 'light' ? '#356380' : '#1C1C1E',
					color: ON_DARK.text,
				}}
			>
				<Container maxWidth="md">
					<Stack
						direction={{ xs: 'column', sm: 'row' }}
						justifyContent="space-between"
						alignItems="center"
						spacing={3}
					>
						<Box sx={{ textAlign: { xs: 'center', sm: 'left' } }}>
							<Logo
								variant="onDark"
								sx={{ width: 110, height: 'auto', mb: 1 }}
							/>
							<Typography variant="body2" sx={{ color: ON_DARK.soft }}>
								Bid &amp; project management for subcontractors
							</Typography>
							<Typography
								variant="caption"
								sx={{ display: 'block', color: ON_DARK.faint, mt: 1 }}
							>
								&copy; {new Date().getFullYear()} {APP_NAME}
							</Typography>
						</Box>

						<Stack
							direction="row"
							spacing={2}
							flexWrap="wrap"
							justifyContent="center"
						>
							<Button
								variant="text"
								size="small"
								onClick={() => navigate('/pricing')}
								sx={footerLinkSx}
							>
								Pricing
							</Button>
							<Button
								variant="text"
								size="small"
								onClick={() => navigate('/signup')}
								sx={footerLinkSx}
							>
								Start trial
							</Button>
							<Button
								variant="text"
								size="small"
								onClick={() => navigate('/login')}
								sx={footerLinkSx}
							>
								Staff login
							</Button>
							<Button
								variant="text"
								size="small"
								onClick={() => navigate('/login?demo=1')}
								sx={{ ...footerLinkSx, opacity: 0.85 }}
							>
								Demo
							</Button>
							<Button
								component={Link}
								to="/terms"
								variant="text"
								size="small"
								sx={footerLinkSx}
							>
								Terms
							</Button>
							<Button
								component={Link}
								to="/privacy"
								variant="text"
								size="small"
								sx={footerLinkSx}
							>
								Privacy
							</Button>
						</Stack>
					</Stack>
					<Typography
						variant="caption"
						sx={{
							display: 'block',
							textAlign: 'center',
							mt: 3,
							color: ON_DARK.faint,
						}}
					>
						Email support from the person who built it — management@bidzbase.com
					</Typography>
				</Container>
			</Box>
		</>
	);
};

export default Footer;
